import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

// Firebase
import { db, functions } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import { connect } from 'react-redux';

// Actions
import { capitalizeFirstLetter } from '../../actions/authActions';

// Global functions
import { getGroupsBySearchTag_Helper } from '../../actions/groupActions';

// Components - imported
import Spinner from '../common/Spinner';
import SportsBlock from './SportsBlock';
import { getMatchesBySportType_Helper } from '../../actions/sportsMatchActions';

const PAGE_SIZE = 3;

// Displays if the user is logged in AND has set up profile
const SportsSection = ({ 
    sport_type,
    nav: {
        website,
        website_loading
    }
}) => {
    // Users List
    const [matchesData, setGroupsData] = useState([]);
    const [gotGroups, setGotGroups] = useState(false);
    const [matchList, setMatchList] = useState([]);

    useEffect(() => {

        fetchMatches();

    }, [sport_type, website, website_loading]);

    useEffect(() => {

        renderMatchesList();

    }, [matchesData, gotGroups]);

    const fetchMatches = async () => {
        console.log('Fetching matches by sport type')
        try {
            if(sport_type && !website_loading) {
                console.log('ABOUT TO FETCH SPORTS MATCHES...');
                // Fetch groups
                let tempGroupList = [];
                tempGroupList = await getMatchesBySportType_Helper({ sport_type, group_id: website?._id, page_size: PAGE_SIZE });

                console.log('UPDATING SPORTS MATCHES...');
        
                setGroupsData(tempGroupList);
                setGotGroups(true);
            }
        } catch (error) {
            console.log("Error: failed to fetch groups by tag");
            console.log(error);
        }
    }

    const renderMatchesList = async () => {
        setMatchList([]);

        if(!gotGroups) {
            setMatchList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(matchesData.length > 0) {
                matchesData.map(match_info => {
                    setMatchList(matchList => [...matchList, (
                        <SportsBlock match_info={match_info} />
                    )])
                }) 
            } else {
                setMatchList(matchList => [...matchList, (
                    <div className="no-rides">
                        <h1>No matches found</h1>
                    </div>
                )])
                
            }
        } 
    }

    // Don't Render component if there's not data
    if(matchesData.length === 0) return <></>;

    // Render the component
    return (
        <div style={{padding: '16px 0', borderBottom: '1px solid #e6ecf0', width: '100%'}}>
            {/* Section Title */}
            <div style={{padding: '0 16px', color:'rgb(15, 20, 25)', marginBottom: '8px', fontWeight:'700', fontSize:'24px', lineHeight:'24px', overflowWrap:'break-word'}}>
                <span style={{fontSize: '1.125rem'}}>{capitalizeFirstLetter(sport_type)} Schedule</span>
            </div>

            {matchList?.slice(0, PAGE_SIZE) || []}

            {/* See more btn */}
            {/* {(matchesData.length > 0 && !(matchesData.length < PAGE_SIZE)) && ( */}

                <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                    <div onClick={() => window.location = `/schedule/football`} className='see_more_btn full_width'>
                        See full schedule
                    </div>
                </div>
            {/* )} */}
        </div>
    )
}

// Prop types for the component
SportsSection.propTypes = {

    // Prop type validation for function to toggle the Authentication modal
    nav: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    nav: state.nav,
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
})(SportsSection);
